import { ReactNode } from "react";
import { ChevronDownIcon, PlusIcon } from "@heroicons/react/24/outline";
import Button from "../Button";

import SliderContainer from "../../../pages/Utilities/SliderContainer";
import { BreadCrumb } from "../Breadcrumbs/interface";

import BreadcrumbsOne from "../Breadcrumbs/BreadcrumbsOne";
import { CollapsibleSidebar } from "../CollapsibleSidebar";

import NavbarMenuButton from "../../../shared/layout/navbar/NavbarMenuButton";
import GetAuthContext from "../../../shared/context/AuthContext";
import { useUtilityStates } from "../../../pages/Utilities/useStates";
import { ORG_IDS } from "src/shared/utils/constants";

interface IProps {
  title: string;
  children?: JSX.Element | Array<JSX.Element> | null;
  breadcrumbs: Array<BreadCrumb>;
  actionItems?: Array<any>;
  actionButtonText?: ReactNode;
  actionMode?: string;
  customActionElements?: ReactNode;
  isMyQueueHomePage?: boolean;
  pageName: string;
}

export default function PageHeader({
  title,
  children,
  breadcrumbs = [],
  actionItems = [],
  actionButtonText = "",
  actionMode = "default",
  customActionElements = null,
  isMyQueueHomePage = false,
  pageName
}: IProps) {
  const {
    getPageConfig,
    userState: { organizationID }
  } = GetAuthContext();

  const { closeSidebar, sidebar, setSidebar } = useUtilityStates(
    (state) => state
  );

  const pageConfig = getPageConfig();

  const isABFLBL = organizationID === ORG_IDS.ABFL;
  const isMFLBL = organizationID === ORG_IDS.MFL;

  const showCreateLeadBtn =
    !pageConfig?.[pageName]?.hideKeys?.includes("createLeadButton") &&
    !isABFLBL &&
    !isMFLBL;

  const setOpen = (name: string) => {
    if (!name) return;

    setSidebar({ isOpen: true, current: name });
  };
  return (
    <>
      <div className="shadow-sm md:shadow-none sticky md:relative top-14 md:top-0 z-[25] md:z-auto bg-white">
        {breadcrumbs?.length > 0 ? (
          <div className="pt-2 md:pt-4 pb-2 px-2 md:pr-2 md:pl-0">
            <BreadcrumbsOne
              breadcrumbs={breadcrumbs}
              isMyQueueHomePage={isMyQueueHomePage}
            ></BreadcrumbsOne>
          </div>
        ) : (
          <div className="pt-4 pb-2"></div>
        )}
      </div>

      <div className="w-full flex items-center justify-between">
        {title && (
          <div className="sm:flex sm:items-end gap-2 sm:flex-row justify-start items-center sm:justify-between sm:w-full my-4 md:mt-4 md:mb-6 mx-3 sm:mx-0">
            {title && (
              <h1 className="text-xl md:text-2xl pb-2 sm:pb-0 font-semibold text-gray-900">
                {title}
              </h1>
            )}

            {showCreateLeadBtn && pageName === "Leads Page" && (
              <Button
                type="button"
                color="primary"
                onClick={() => setOpen("create-customer")}
                className="flex items-center justify-center"
              >
                {/* One button among 2 Create Lead buttons on Leads listing page */}
                <PlusIcon className="mr-2 text-white h-3 w-auto" />
                Create Lead
              </Button>
            )}

            {children}
          </div>
        )}
        {actionMode === "default" && actionItems?.length > 0 ? (
          <NavbarMenuButton
            menuItems={actionItems}
            menuDirection="right"
            srText="bulk actions"
            preContent=""
            styles={{
              button: "bg-indigo-600 rounded-md",
              container: "hidden md:block mb-6 min-w-max"
            }}
            buttonText={
              <div className="text-center font-medium text-white flex items-center justify-center">
                {actionButtonText || "Actions"}
                <ChevronDownIcon className="w-4 h-4 text-white ml-2" />
              </div>
            }
          />
        ) : null}
        {actionMode !== "default" && <div>{customActionElements}</div>}
        <CollapsibleSidebar
          show={sidebar?.isOpen}
          setShow={closeSidebar}
          style={{
            container: `!p-0 ${
              [
                "existing-offers",
                "success",
                "offer-calculator",
                "lead-created"
              ].includes(sidebar?.current)
                ? "w-full"
                : ""
            }`
          }}
        >
          <SliderContainer
            close={closeSidebar}
            current={sidebar?.current}
            pageName={pageName as string}
          />
        </CollapsibleSidebar>
      </div>
    </>
  );
}
